// useBalance.ts
import { useState, useEffect, useCallback } from 'react';
import { api, Balance } from '../components/custom/balance/api'; 
import { useAuthStore } from '../store/useAuthStore3';
// import { useAuthStore } from '../../../store/useAuthStore3.ts';

export const useBalance = (pollingInterval = 50000) => {
  const [balance, setBalance] = useState<Balance | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const { accessToken } = useAuthStore();
  const isAuthenticated = !!accessToken;

  const fetchBalance = useCallback(async () => {
    
    if (!isAuthenticated) {
      console.log('useBalance: skipping, isAuthenticated:', isAuthenticated);
      setBalance(null);
      setIsLoading(false);
      return;
    }

    console.log('useBalance: fetching balance, isAuthenticated:', isAuthenticated);
    try {
      const res = await api.getBalance();
      
      if (!res || res.value === undefined) {
        console.error('useBalance BalanceError');
        return;
      }
      
      setBalance(res);
    } catch (error) {
      console.error('useBalance LoadingError', error);
      setBalance(null);
    } finally {
      setIsLoading(false);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    fetchBalance();
    const intervalId = setInterval(fetchBalance, pollingInterval);
    return () => clearInterval(intervalId);
  }, [fetchBalance, pollingInterval, isAuthenticated]);

  // Возвращаем не только баланс, но и метод для ручного обновления и статус загрузки
  return { balance, isLoading, refresh: fetchBalance };
};